(function () {
  'use strict';

  var section = document.querySelector('[data-merch-pdp]');
  if (!section) return;

  var configEl = document.getElementById('merch-pdp-config');
  if (!configEl) return;
  var CONFIG = JSON.parse(configEl.textContent);

  /* ===== Gallery ===== */
  var mainImage = section.querySelector('[data-merch-main-image]');
  var thumbEls = section.querySelectorAll('[data-merch-thumb]');
  var carouselSlides = section.querySelectorAll('[data-merch-carousel-slide]');
  var currentImageIdx = 0;

  // filteredMedia is the subset shown for the active variant; lightbox uses it
  var filteredMedia = CONFIG.media.slice();

  function patternForVariant(variantId) {
    var swatch = section.querySelector('[data-merch-variant-id="' + variantId + '"]');
    if (!swatch) return null;
    var url = swatch.dataset.merchVariantImage || '';
    if (!url) return null;
    // e.g. "Hat_Ecru_1.jpg?v=123" → strip query → strip ext → strip trailing _N → "hat_ecru"
    var filename = url.split('?')[0].split('/').pop();
    filename = filename.replace(/\.[^.]+$/, '').replace(/_\d+$/, '');
    return filename.toLowerCase();
  }

  function filterGalleryByVariant(variantId) {
    var pattern = patternForVariant(variantId);
    var variantImages = pattern
      ? CONFIG.media.filter(function (m) { return m.src.toLowerCase().indexOf(pattern) !== -1; })
      : [];

    // Fall back to all images if no pattern match
    filteredMedia = variantImages.length > 0 ? variantImages : CONFIG.media.slice();

    var visibleSrcs = {};
    filteredMedia.forEach(function (m) { visibleSrcs[m.src] = true; });

    // Show/hide thumbs
    thumbEls.forEach(function (thumb) {
      var idx = parseInt(thumb.dataset.merchThumb, 10);
      var media = CONFIG.media[idx];
      var show = media && visibleSrcs[media.src];
      thumb.style.display = show ? '' : 'none';
      thumb.classList.remove('is-active');
    });

    // Show/hide carousel slides
    carouselSlides.forEach(function (slide) {
      var idx = parseInt(slide.dataset.merchCarouselSlide, 10);
      var media = CONFIG.media[idx];
      slide.style.display = (media && visibleSrcs[media.src]) ? '' : 'none';
    });

    // Update main image to first in filtered set
    if (filteredMedia.length > 0 && mainImage) {
      mainImage.src = filteredMedia[0].src;
      mainImage.srcset = filteredMedia[0].srcset;
      mainImage.alt = filteredMedia[0].alt;
      currentImageIdx = 0;

      var firstSrc = filteredMedia[0].src;
      thumbEls.forEach(function (thumb) {
        var idx = parseInt(thumb.dataset.merchThumb, 10);
        var media = CONFIG.media[idx];
        thumb.classList.toggle('is-active', !!(media && media.src === firstSrc));
      });
    }
  }

  // Thumbnails → open lightbox using filtered set
  thumbEls.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.dataset.merchThumb, 10);
      var media = CONFIG.media[idx];
      var filteredIdx = media ? filteredMedia.findIndex(function (m) { return m.src === media.src; }) : 0;
      if (filteredIdx === -1) filteredIdx = 0;
      if (window.PdpLightbox) window.PdpLightbox.open(filteredMedia, filteredIdx);
    });
  });

  // Main image → open lightbox at current position
  if (mainImage) {
    mainImage.addEventListener('click', function () {
      if (window.PdpLightbox) window.PdpLightbox.open(filteredMedia, currentImageIdx);
    });
  }

  // Mobile carousel slides → open lightbox using filtered set
  carouselSlides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      var idx = parseInt(slide.dataset.merchCarouselSlide, 10);
      var media = CONFIG.media[idx];
      var filteredIdx = media ? filteredMedia.findIndex(function (m) { return m.src === media.src; }) : 0;
      if (filteredIdx === -1) filteredIdx = 0;
      if (window.PdpLightbox) window.PdpLightbox.open(filteredMedia, filteredIdx);
    });
  });

  // Initialize on load
  filterGalleryByVariant(CONFIG.currentVariantId);

  /* ===== Variant Selector ===== */
  var swatches = section.querySelectorAll('[data-merch-variant-id]');
  var colorName = section.querySelector('[data-merch-color-name]');
  var priceEl = section.querySelector('[data-merch-price]');
  var compareEl = section.querySelector('[data-merch-compare]');
  var addBtn = section.querySelector('[data-merch-add-to-cart]');
  var selectedVariantId = CONFIG.currentVariantId;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('is-selected'); s.setAttribute('aria-pressed', 'false'); });
      swatch.classList.add('is-selected');
      swatch.setAttribute('aria-pressed', 'true');

      selectedVariantId = parseInt(swatch.dataset.merchVariantId, 10);
      var title = swatch.dataset.merchVariantTitle;
      var price = parseInt(swatch.dataset.merchVariantPrice, 10);
      var compare = swatch.dataset.merchVariantCompare ? parseInt(swatch.dataset.merchVariantCompare, 10) : null;
      var available = swatch.dataset.merchVariantAvailable === 'true';

      if (colorName) colorName.textContent = title;
      if (priceEl) priceEl.textContent = formatMoney(price);

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = formatMoney(compare);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      section.classList.toggle('is-sold-out', !available);
      [qtyInput, qtyMinus, qtyPlus].forEach(function (control) {
        if (control) control.disabled = !available;
      });
      filterGalleryByVariant(selectedVariantId);
    });
  });

  /* ===== Quantity Controls ===== */
  var qtyInput = section.querySelector('[data-merch-qty-input]');
  var qtyMinus = section.querySelector('[data-merch-qty-minus]');
  var qtyPlus = section.querySelector('[data-merch-qty-plus]');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* ===== Add to Cart ===== */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding...';

      addToCart(selectedVariantId, qty)
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          addBtn.textContent = 'Error — Try Again';
          addBtn.classList.remove('is-loading');
          setTimeout(function () {
            addBtn.textContent = 'Add to Cart';
          }, 2000);
        });
    });
  }

  /* ===== Cross-Sell Add to Cart ===== */
  var crossSellBtn = section.querySelector('[data-merch-cross-sell-add]');
  if (crossSellBtn) {
    crossSellBtn.addEventListener('click', function () {
      if (crossSellBtn.disabled) return;
      var variantId = parseInt(crossSellBtn.dataset.variantId, 10);
      var origText = crossSellBtn.innerHTML;

      crossSellBtn.textContent = 'Adding...';
      crossSellBtn.disabled = true;

      addToCart(variantId, 1)
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          crossSellBtn.textContent = 'Error';
          setTimeout(function () {
            crossSellBtn.innerHTML = origText;
            crossSellBtn.disabled = false;
          }, 2000);
        });
    });
  }

  /* ===== Accordion ===== */
  var accordionTriggers = section.querySelectorAll('[data-merch-accordion-trigger]');
  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-merch-accordion-item]');
      if (!item) return;
      // aria-expanded is written from the class the toggle just produced, so
      // the two can never disagree.
      var isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();
